export const itAndMe = [
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Info voor de leraar</h2>\n<h3 class="ck5h3">Inhoudelijk</h3>\n<p>Om de meer gevorderde technieken in Word onder de knie te krijgen, zullen de leerlingen in de rest van de lessen van deze module een tijdschrift opmaken. In deze les bedenken ze een eigen vereniging waarvoor ze een tijdschrift willen opmaken en beginnen ze al met pagina-indeling.</p>\n<h3 class="ck5h3">Praktisch</h3>\n<p>De leerlingen hebben oortjes of een koptelefoon nodig om de video te beluisteren.</p>\n<p>De leerlingen dienen hun werkstuk, het tijdschrift, pas tegen het einde van de lessenreeks in. Je kan er ook voor kiezen om tussentijdse evaluaties te doen. In dat geval kunnen ze na elke les een deel van hun document insturen.</p>\n<p>Download hier de&nbsp;<a class="styledLink SlideViewer__StyledButton SlideViewer__DownloadLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" download-file-name="ITME2_WordII_Rubric_Tijdschrift" download-url="https://codefeverpublic.blob.core.windows.net/public-content/documents/aab5d5e1fd8a49039cf55ca71e6518ce.pdf"> rubric&nbsp;</a> voor de volledige opdracht. Je kan deze ook al delen met je leerlingen.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130851',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 1,
    time: null,
    title: 'Info voor de leraar',
    viewModes: ['PROJECTION'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">IT&amp;ME - WORD II</h3>\n  <h2 class="dotted-in-editor">Les 2 - Een nieuwe vereniging starten</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/739591e52f5a416ead144353152e753c.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130852',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 2,
    time: null,
    title: ' Les 2 - Een nieuwe vereniging starten',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div>\n <h2 class="dotted-in-editor">inhoud les</h2>\n <div class="learnContainer">\n  <div class="mainContent dotted-in-editor">\n   <h3>Na deze les kan je …</h3>\n   <div class="check-list">\n    <ul>\n     <li>de functies voor pagina-indeling in Word doelgericht toepassen.</li>\n     <li>doelgericht nieuwe stijlen ontwerpen in Word.</li>\n     <li>een inhoudstafel genereren op basis van stijlen.</li>\n    </ul>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n    <p>&nbsp;</p>\n   </div>\n   <div class="ftrprfLogo">\n    &nbsp;\n   </div>\n  </div>\n  <div class="dotted-in-editor imagePlaceholder">\n   <span><strong><img class="image_resized" style="width:506px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/ccab545807814205b8ad7edc30ff00ee.jpg" alt=""></strong></span>\n  </div>\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130853',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 3,
    time: null,
    title: 'Inhoud les',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Wie is coach Youssef?</h2>\n<p>Deze lessen zal jij zelfstandig doorlopen. Coach Youssef is er om jou te helpen.&nbsp;<br>Hij zal jou doorheen de lessen enkele tips en tricks geven om de module tot een goed einde te brengen.<br>Op een slide waar Youssef een tip heeft zal je hem onderaan rechts zien verschijnen met een rood bolletje.</p>\n<ul>\n <li>Wanneer je op Youssef klikt, zal zijn boodschap openspringen. Om de volledige tip te zien, klik je op de blauwe knop.</li>\n <li>Om de coach terug te sluiten, klik je op het kruisje.</li>\n <li>Probeer het al eens uit op deze slide!</li>\n</ul>\n<figure class="image image_resized image-style-align-right" style="width:24%;">\n <img style="aspect-ratio:886/886;" src="https://codefeverpublic.blob.core.windows.net/public-content/images%2F4f65604d5f0b4547b6c3fe4b55183daf.png" alt="" width="886" height="886">\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content: '<p>Hier zullen mijn tips verschijnen doorheen de les.</p>',
        id: '7137',
        title: 'Hoi! Ik ben er om je te helpen.',
      },
    ],
    id: '2130854',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 4,
    time: null,
    title: 'Wie is coach Youssef?',
    viewModes: ['PROJECTION'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<figure class="image image_resized" style="width:1139px;">\n <img style="aspect-ratio:6250/3517;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/4b07baf5c3aa423eb4342707799d6d28.png" width="6250" height="3517">\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2137049',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 5,
    time: null,
    title: 'Structuur les',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<p><iframe class="ck iframe ck-iframe ck-iframe-middle ck-iframe-showNoBorders ck-iframe-showNoScrollbars" data-alignment="middle" height="100%" name="undefined" src="https://player.vimeo.com/video/938163259" title="" width="100%">&nbsp;</iframe></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2131527',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 6,
    time: null,
    title: 'Video',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">1. Een tijdschrift</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/739591e52f5a416ead144353152e753c.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130855',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 7,
    time: null,
    title: '1. Een tijdschrift',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'whiteLavaLamp',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="aspect-ratio:402/401;width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/07d80e48de9f4e79a7fd30ab16472d50.png" alt="" width="402" height="401">\n </div>\n <h2 class="dotted-in-editor">1. Een tijdschrift</h2>\n <h3 class="ck5h3">Brainstorm</h3>\n <figure class="table">\n  <table style="border-style:solid;">\n   <tbody>\n    <tr>\n     <td><strong>Doelen</strong></td>\n     <td><strong>Tijdsinschatting</strong></td>\n    </tr>\n    <tr>\n     <td>Denk doelgericht na over een idee dat je in een tijdschrift kan uitwerken.</td>\n     <td>10 minuten</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n <p><strong>Opdracht</strong></p>\n <p>In de komende lessen ga je zelf een tijdschrift opmaken! Maar eerst heb je natuurlijk een idee nodig.</p>\n <p>Denk na welke vereniging je wil oprichten. Hou hierbij rekening met wat er in je tijdschrift moet komen: zal je alle pagina\'s kunnen vullen?</p>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130856',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 8,
    time: null,
    title: '1. Een tijdschrift',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.1 Inhoud tijdschrift</h2>\n<h3 class="ck5h3">Bezint eer ge begint</h3>\n<p>Bekijk - voor je een vereniging verzint - wat er in je tijdschrift zal moeten komen. Zo kan je met de voorwaarden rekening houden als je een idee verzint.</p>\n<p>Het tijdschrift heeft</p>\n<ul>\n <li>12 pagina\'s</li>\n <li>Een voorblad en achterblad</li>\n <li>Een inhoudsopgave</li>\n <li>2 pagina\'s waarin de vereniging en het bestuur worden voorgesteld</li>\n <li>3 pagina\'s met nieuwsartikelen - <i>(zorg dat je over je idee nieuwsberichten kan vinden)</i></li>\n <li>Een lijst met komende activiteiten - <i>(zorg ervoor dat je activiteiten voor je vereniging kan verzinnen)</i></li>\n</ul>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2131528',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 9,
    time: null,
    title: '1.1 Inhoud tijdschrift',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">1.2 Verzin een vereniging</h2>\n<p>Denk na over de voorwaarden voor het tijdschrift en verzin zelf een vereniging.</p>\n<p class="title-with-background title-with-background--question">Welke vereniging wil jij oprichten?<br><span class="text-tiny">naam - doel - reden - leden</span></p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2131529',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '352509',
        placeholder:
          "Verzin een naam voor je vereniging en omschrijf in een drietal zinnen wat het doel van je vereniging is, wie de doelgroep is en waarom je zo'n vereniging kiest.",
        questionAnswerOpen: null,
        scorePerCorrectAnswer: '1',
        showModelAnswer: true,
        solution: null,
        type: 'OPEN',
        value: null,
      },
    ],
    sequence: 10,
    time: null,
    title: '1.2 Verzin een vereniging',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">2. Pagina-indeling</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/361072957e034487a99581fc85ef33a6.svg">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130871',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 11,
    time: null,
    title: '2. Pagina-indeling',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'whiteLavaLamp',
    content:
      '<div class="titleWithIconSlide">\n <div class="dotted-in-editor imagePlaceholder float-right">\n  <img class="image_resized" style="aspect-ratio:402/401;width:126px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/07d80e48de9f4e79a7fd30ab16472d50.png" alt="" width="402" height="401">\n </div>\n <h2 class="dotted-in-editor">2. Pagina-indeling</h2>\n <h3 class="ck5h3">Let\'s get started!</h3>\n <figure class="table">\n  <table style="border-style:solid;">\n   <tbody>\n    <tr>\n     <td><strong>Doelen</strong></td>\n     <td><strong>Tijdsinschatting</strong></td>\n    </tr>\n    <tr>\n     <td><p>In dit onderdeel leer je:</p>\n      <ul>\n       <li>de functies voor pagina-indeling in Word doelgericht toepassen.</li>\n       <li>doelgericht nieuwe stijlen ontwerpen in Word.</li>\n       <li>een inhoudstafel genereren op basis van stijlen.</li>\n      </ul></td>\n     <td>30-35 minuten</td>\n    </tr>\n   </tbody>\n  </table>\n </figure>\n <p><strong>Opdracht</strong></p>\n <p>Je zit vast al vol ideeën! Bewaar ze nog even, want eerst gaan we ervoor zorgen dat de instellingen voor pagina-indeling klaarstaan. Selecteer het juiste formaat, het juiste aantal pagina\'s en maak de tussentitels aan.</p>\n <p>Door dit al te doen, zal je later perfect weten waar je uitkomt en kom je niet voor verassingen te staan.</p>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130878',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 12,
    time: null,
    title: '2. Pagina-indeling',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.1 Nieuw word-document</h2>\n<h3 class="ck5h3">Startdocument</h3>\n<p>Download dit<a class="styledLink SlideViewer__StyledButton SlideViewer__DownloadLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" download-file-name="ITME2_WordII_L2_Startdocument" download-url="https://codefeverpublic.blob.core.windows.net/public-content/documents/2ded722164fb4a9b912e5865833aaa87.docx"> startdocument </a>en sla het meteen op.</p>\n<p>In het document zie je de vooropgestelde structuur al staan waar je straks in zal werken.<br>Voor je hierin kan werken, zal je de pagina-indeling moeten klaarzetten.</p>\n<p class="SlideViewer__Badge warning"><strong>OPGELET</strong><br>Je zal de komende lessen steeds in ditzelfde bestand werken. Kies een duidelijke naam en sla het document op waar je het makkelijk terug kan vinden.<br><strong>Naam document</strong>: “IT&amp;ME2_WordII_Tijdschrift_Voornaam_Achternaam”</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2131530',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 13,
    time: null,
    title: '2.1 Nieuw Word-document',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.2 Katern</h2>\n<h3 class="ck5h3">Wat is dat?</h3>\n<p>Je wil een tijdschrift opmaken. Kies er daarom voor om je pagina\'s als katernen in te delen.</p>\n<figure class="image image_resized image-style-align-right" style="width:380px;">\n <img style="aspect-ratio:618/575;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/b9343a9a3f4f46e28aa8b6a5a99982a7.png" width="618" height="575">\n</figure>\n<p class="SlideViewer__Badge info"><strong>DEFINITIE</strong><br>Een <strong>katern</strong> is een verzameling van in elkaar geschoven, gevouwen<br>bladen (of \'folio\'s\').</p>\n<p>Een katern die bestaat uit 3 folio\'s, dit kunnen bijvoorbeeld 3 A4-bladen zijn, zal 12 bladzijden tellen.</p>\n<p>&nbsp;</p>\n<p class="SlideViewer__Badge warning"><strong>OPGELET</strong><br>Als je werkt met katernen, moet je aantal pagina\'s altijd een<br><strong>veelvoud van 4</strong> zijn.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2131531',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 14,
    time: null,
    title: '2.2 Katern',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'white',
    content:
      '<figure class="image image_resized image-style-align-right" style="width:380px;">\n <img style="aspect-ratio:559/182;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/4a6e115ecd53457fb40cc1a879a32c78.png" width="559" height="182">\n</figure>\n<h2 class="ck5h2">2.2 Katern</h2>\n<h3 class="ck5h3">Voer de stappen uit</h3>\n<p style="margin-left:40px;">1. Ga in Word via het tabblad <strong>Indeling</strong> naar de groep <strong>Pagina-instelling</strong> en klik op het pijltje in de rechterhoek.</p>\n<figure class="image image_resized image-style-align-right" style="width:380px;">\n <img style="aspect-ratio:807/861;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/3974a333744341c49f3122ade313fa4d.png" width="807" height="861">\n</figure>\n<p style="margin-left:40px;">2. Kies bij pagina\'s voor <strong>Katern </strong>en<strong> 12 vellen per boekje</strong>.</p>\n<p class="SlideViewer__Badge tip">Je afdrukstand verandert automatisch naar liggend, maar je zal<br>merken dat je op een staand formaat werkt. Je zal ook merken dat<br>je op A5-formaat werkt, terwijl het printformaat toch nog op A4 is<br>ingesteld.&nbsp;<br><br>In totaal zullen namelijk drie A4-pagina\'s uitgeprint worden als je<br>klaar bent. Die pagina\'s kan je in elkaar vouwen tot een boekje.<br><br>Door deze instelling hoef je niet meer over katernen na te denken:&nbsp;<br>jij kan gewoon je twaalf pagina\'s opmaken, Word zorgt ervoor dat<br>ze juist afgedrukt worden.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2131532',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 15,
    time: null,
    title: '2.2 Katern',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.3 Marges instellen</h2>\n<figure class="image image_resized image-style-align-right" style="width:380px;">\n <img style="aspect-ratio:438/618;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/09374c1445e64cf181127dac55046254.png" width="438" height="618">\n</figure>\n<h3 class="ck5h3">Zorg dat je voldoende ruimte hebt</h3>\n<p>&nbsp;</p>\n<p><u>Opdracht</u>:</p>\n<p>Stel de marges van je document in op 1,5 cm.</p>\n<ol>\n <li>Ga via het tabblad <strong>Indeling </strong>naar de groep <strong>Pagina-instelling</strong>.</li>\n <li>Klik op <strong>Marges </strong>en kies <strong>Aangepaste marges</strong>.</li>\n <li>Vul bij <strong>Marges </strong>overal <strong>1,5 cm</strong> in.</li>\n</ol>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2132418',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 16,
    time: null,
    title: '2.3 Marges instellen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.4 Pagina\'s klaarzetten</h2>\n<p>Zet de pagina\'s van je tijdschrift klaar. Het moeten er twaalf zijn.</p>\n<figure class="table">\n <table style="border-style:solid;">\n  <tbody>\n   <tr>\n    <td style="background-color:hsl(0, 0%, 90%);"><span style="color:rgb(76,151,255);">Voorblad</span><br><span style="color:rgb(76,151,255);"><i>[leeg blad]</i></span><br><span style="color:rgb(76,151,255);">Voorwoord</span><br><span style="color:rgb(76,151,255);">Inhoudstafel</span><br>Themanummer - Hoofdtitel<br><span style="color:rgb(76,151,255);">Themanummer - Tussentitel (1)</span><br><span style="color:rgb(76,151,255);">Themanummer - Tussentitel (1)</span><br>Nieuwsrubriek - Hoofdtitel<br><span style="color:rgb(76,151,255);">Nieuwsrubriek - Tussentitel (1)</span><br><span style="color:rgb(76,151,255);">Nieuwsrubriek - Tussentitel (2)</span><br><span style="color:rgb(76,151,255);">Nieuwsrubriek - Tussentitel (3)</span><br><span style="color:rgb(76,151,255);">Bronnen</span><br><span style="color:rgb(76,151,255);">Activiteiten</span><br>Achterblad</td>\n    <td><p><u>Opdracht:</u></p><p>Deze titels staan al klaar in je startdocument.</p><p>Voeg na elke titel die hiernaast in het <span style="color:rgb(76,151,255);">blauw </span>staat&nbsp;<br>een <strong>pagina-einde</strong> in. Zo zal je op 12 pagina\'s uitkomen.</p><p>&nbsp;&nbsp;<a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="&nbsp;Hoe?" data-modal-title="Pagina-einde invoegen" data-modal-size="M" data-modal-content="<p><span style=&quot;background-color:#ffffff;color:#000000;&quot;>Om een pagina-einde in te voegen, druk je op de sneltoetsencombinatie <strong>Ctrl + Enter</strong>, of klik je in het lint op het tabblad <strong>Invoegen</strong>, en vervolgens in de groep <strong>Pagina\'s </strong>op <strong>Pagina-einde</strong>.</span></p>"> Hoe?</a>&nbsp;</p></td>\n   </tr>\n  </tbody>\n </table>\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2131533',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 17,
    time: null,
    title: "2.4 Pagina's klaarzetten",
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.5 Stijlen</h2>\n<h3 class="ck5h3">Consistentie</h3>\n<p>Stijlen bepalen het lettertype, de lettergrootte, de kleur, de uitlijning, het inspringen, de witruimte, etc. … van de tekst. Ze zorgen ook voor een <strong>uniforme structuur</strong> in je document.</p>\n<p><u>Opdracht</u>:</p>\n<p>Maak drie nieuwe stijlen aan: één voor titels (<i>Kop 1</i>), één voor tussentitels (<i>Kop 2</i>) en één voor tekst (<i>Standaard</i>).&nbsp;<br>Je kan dit doen door stijlen te wijzigen of zelf een stijl te maken.</p>\n<figure class="table">\n <table style="border-style:solid;">\n  <thead>\n   <tr>\n    <th><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="Stijl wijzigen" data-modal-title="Stijl wijzigen" data-modal-size="M" data-modal-content="<p style=&quot;margin-left:0px;text-align:center;&quot;><br><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images%2F3807c70a5aaa4c71b9d47356ef5a9e85.png&quot; alt=&quot;&quot;></p><p style=&quot;margin-left:!important;text-align:center;&quot;><img src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images%2F07ae5f47fd894c7189e7f308fde4612a.png&quot; alt=&quot;&quot;></p>">&nbsp;Stijl wijzigen&nbsp;</a>&nbsp;</th>\n    <th><a class="SlideViewer__StyledButton SlideViewer__ModalLink" data-label="&nbsp;Stijl maken&nbsp;" data-modal-title="Stijl maken" data-modal-size="M" data-modal-content="<figure class=&quot;image image_resized&quot; style=&quot;width:253px;&quot;><img style=&quot;aspect-ratio:312/365;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images%2F3039d2e4666446209e7d8f1f9c136f96.png&quot; alt=&quot;&quot; width=&quot;312&quot; height=&quot;365&quot;></figure><figure class=&quot;image image_resized&quot; style=&quot;width:506px;&quot;><img style=&quot;aspect-ratio:1041/856;&quot; src=&quot;https://codefeverpublic.blob.core.windows.net/public-content/images%2F77b24278f25a46ac82f65240aeb2b9ea.PNG&quot; alt=&quot;&quot; width=&quot;1041&quot; height=&quot;856&quot;></figure>">&nbsp;Stijl maken</a>&nbsp;</th>\n   </tr>\n  </thead>\n  <tbody>\n   <tr>\n    <td>\n     <ol>\n      <li><span style="background-color:#ffffff;color:#000000;">Klik op de uitvouwknop in de rubriek stijlen. Het instelvenster voor stijlen verschijnt.</span></li>\n      <li><span style="background-color:#ffffff;color:#000000;">Kies de stijl die je wil wijzigen &amp; klik op het pijltje ernaast.</span></li>\n      <li><span style="background-color:#ffffff;color:#000000;">Kies voor&nbsp;<strong>Wijzigen</strong>.</span></li>\n      <li><span style="background-color:#ffffff;color:#000000;">Dialoogkader voor een stijl te wijzigen verschijnt.</span></li>\n     </ol></td>\n    <td>\n     <ol>\n      <li><span style="background-color:#ffffff;color:#000000;">Klik op de uitvouwknop in de rubriek stijlen. Het instelvenster voor stijlen verschijnt.</span></li>\n      <li><span style="background-color:#ffffff;color:#000000;">Kies voor <strong>A+</strong>.</span></li>\n      <li><span style="background-color:#ffffff;color:#000000;">Het dialoogkader voor een nieuwe stijl verschijnt.</span></li>\n     </ol></td>\n   </tr>\n  </tbody>\n </table>\n</figure>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p>Een goede stijl is sober en doeltreffend. Beperk het aantal lettertypes en kleuren in één document.</p>',
        id: '7180',
        title: 'Een goede stijl',
      },
    ],
    id: '2131534',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 18,
    time: null,
    title: '2.5 Stijlen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.5 Stijlen</h2>\n<p>Je stelt een stijl in voor titels (<i>Kop 1</i>), tussentitels (<i>Kop 2</i>) en tekst (<i>Standaard</i>).</p>\n<figure class="image image_resized image-style-align-right" style="width:506px;">\n <img style="aspect-ratio:1042/851;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/9d52a2e2738741d18b56ba77f6341712.png" width="1042" height="851">\n</figure>\n<p class="SlideViewer__Badge tip"><strong>TIP</strong><br>Gebruik dezelfde lettertypes en beperk het aantal<br>kleuren in je document. Zo zal het geheel uniform en<br>overzichtelijk ogen.</p>\n<p>In het dialoogkader voor stijlen kan je heel wat instellingen voor teken- en alineaopmaak bewerken.</p>\n<p><u>Opdracht</u>:</p>\n<p>Stel voor elke stijl een passend(e) lettertype, lettergrootte en letterkleur in.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2132748',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 19,
    time: null,
    title: '2.5 Stijlen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.5 Stijlen</h2>\n<h3 class="ck5h3">Toepassen</h3>\n<p><u>Opdracht</u>:</p>\n<p>Pas je zelfgemaakte stijlen al toe op de titels en tussentitels in je document.&nbsp;<br>Verwijder het titeltje <i>[leeg blad]</i>; dit was een placeholder en dus geen echte titel.</p>\n<figure class="table">\n <table style="border-style:solid;">\n  <tbody>\n   <tr>\n    <th>Titels</th>\n    <td>Voorwoord; Inhoudsopgave; Hoofdthema; Nieuwsrubriek; Bronnen; Komende activiteiten</td>\n   </tr>\n   <tr>\n    <th>Tussentitels</th>\n    <td>Tussentitels bij het hoofdthema; Nieuwsartikel 1; Nieuwsartikel 2; Nieuwsartikel 3</td>\n   </tr>\n   <tr>\n    <th>Standaard</th>\n    <td>Typ één zinnetje onder het voorwoord: “Dit is hoe de standaard tekststijl er zal uitzien.”</td>\n   </tr>\n  </tbody>\n </table>\n</figure>\n<p>&nbsp;</p>\n<p><strong>Kies eventueel ook al een hoofdtitel voor op het voorblad van je tijdschrift en stel hiervoor nog een nieuwe stijl in. Dit kan je later nog aanpassen.</strong></p>',
    execution: null,
    groupRoles: [],
    hints: [
      {
        content:
          '<p>De tweede bladzijde laat je best leeg, omdat dit de achterkant van je voorblad is. Het hoort dus eigenlijk bij de kaft.</p>',
        id: '7256',
        title: 'Waarom een leeg blad?',
      },
    ],
    id: '2131537',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 20,
    time: null,
    title: '2.5 Stijlen',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">2.6 Inhoudsopgave</h2>\n<p><span style="background-color:#ffffff;color:#000000;">Om een document overzichtelijk te maken, kan je een <strong>inhoudsopgave </strong>genereren op basis van de <strong>stijlen</strong>.</span></p>\n<p><span style="background-color:#ffffff;color:#000000;"><u>Opdracht</u>:</span></p>\n<p><span style="background-color:#ffffff;color:#000000;">Genereer een inhoudsopgave.&nbsp;</span></p>\n<ol>\n <li>Verwijder de tussentitel ‘Inhoudsopgave’ en plaats de cursor op die plaats.&nbsp;<br>Zo zal je inhoudsopgave straks meteen op de juiste plaats komen.</li>\n <li><span style="background-color:#ffffff;color:#000000;">Ga in het tabblad <strong>Verwijzingen</strong>&nbsp;naar de groep <strong>Inhoudsopgave</strong>.&nbsp;</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">Klik op de knop <strong>Inhoudsopgave</strong>&nbsp;kies voor <strong>Aangepaste inhoudsopgave</strong>.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">Bij <strong>Opties</strong> kan je ervoor zorgen dat de inhoudsopgave op basis van je zelfgemaakte stijlen gegenereerd wordt.</span></li>\n <li><span style="background-color:#ffffff;color:#000000;">Pas de titel van je inhoudstafel aan naar de kopstijl van jouw document, als dit nog niet automatisch gebeurd is.</span></li>\n</ol>\n<p class="SlideViewer__Badge tip"><strong>TIP</strong><br>Geen zorgen als je nog geen officiële tussentitels gekozen hebt: je kan je inhoudsopgave doorheen de lessen gemakkelijk updaten, door op <strong>Bijwerken</strong> te klikken.<br>Als er pagina\'s verschuiven of titels veranderen, werk je de inhoudsopgave best bij.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2131538',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 21,
    time: null,
    title: '2.6 Inhoudsopgave',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">Test jezelf!</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="aspect-ratio:90/150;width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/e645a33b3d3e4b9e8b5ff03478760bba.svg" width="90" height="150">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130875',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 22,
    time: null,
    title: 'Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div class="check-list">\n <h2 class="ck5h2">Checklist: Heb je alles toegevoegd?</h2>\n <p>&nbsp;</p>\n <ul>\n  <li>Pagina-indeling: katernen</li>\n  <li>12 pagina\'s met placeholders voor titels</li>\n  <li>Nieuwe stijlen gemaakt en toegepast</li>\n  <li>Inhoudstafel klaargezet</li>\n  <li>Marges ingesteld</li>\n </ul>\n</div>\n<p>&nbsp;</p>\n<p>Bekijk hier de<a class="styledLink SlideViewer__StyledButton SlideViewer__DownloadLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" download-file-name="ITME2_WordII_L2_Voorbeeldoplossing" download-url="https://codefeverpublic.blob.core.windows.net/public-content/documents/149b6662ad3349f18679276ad511d022.pdf"> voorbeeldoplossing </a>van les 2.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2132324',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 23,
    time: null,
    title: 'Checklist: Heb je alles toegevoegd?',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Test jezelf!</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Hoeveel bladzijden heeft een boekje, als het bestaat uit 5 folio\'s?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2132077',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '352587',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            id: '1132803',
            numbering: null,
            value: '<p>5</p>',
          },
          {
            id: '1132804',
            numbering: null,
            value: '<p>10</p>',
          },
          {
            id: '1132805',
            numbering: null,
            value: '<p>15</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1132806',
            numbering: null,
            value: '<p>20</p>',
          },
          {
            id: '1132807',
            numbering: null,
            value: '<p>24</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 24,
    time: null,
    title: 'Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Test jezelf!</h2>\n<p>&nbsp;</p>\n<p class="title-with-background title-with-background--question">Welke stijlen zijn het duidelijkst?</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2132419',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '352588',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            id: '1132808',
            numbering: null,
            value:
              '<figure class="image image_resized" style="width:253px;">\n <img style="aspect-ratio:517/251;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/4d07a512d6a7417c84ec1200d8e996c0.png" width="517" height="251">\n</figure>',
          },
          {
            id: '1132809',
            numbering: null,
            value:
              '<figure class="image image_resized" style="width:126px;">\n <img style="aspect-ratio:213/179;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/2d9f70c0098b4aa6847b502e7632f144.png" width="213" height="179">\n</figure>',
          },
          {
            correct: true,
            explanation: '',
            id: '1132810',
            numbering: null,
            value:
              '<figure class="image image_resized" style="width:126px;">\n <img style="aspect-ratio:188/164;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/93e2639539d040a991afb62cdd9479bb.png" width="188" height="164">\n</figure>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 25,
    time: null,
    title: 'Test jezelf!',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: 'FTRPRFSideBlueLavaLamp',
    content:
      '<div class="titleSlide">\n <div>\n  <h3 class="dotted-in-editor">&nbsp;</h3>\n  <h2 class="dotted-in-editor">Reflectie</h2>\n </div>\n <div class="dotted-in-editor" style="text-align:center;">\n  <img class="image_resized" style="aspect-ratio:90/150;width:253px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/e645a33b3d3e4b9e8b5ff03478760bba.svg" width="90" height="150">\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2132065',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 26,
    time: null,
    title: 'Reflectie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Reflectie</h2>\n<p>Hoe goed denk je dat je de leerdoelen van deze les bereikt hebt? Duid aan wat past voor jou.</p>\n<p class="title-with-background title-with-background--question title-with-background--statement">Ik kan de functies voor pagina-indeling in Word doelgericht toepassen.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130876',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '352464',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1132444',
            numbering: null,
            value: '<p><strong>Helemaal niet goed </strong>😵‍💫</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1132445',
            numbering: null,
            value: '<p><strong>Niet goed </strong>🫤</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1132446',
            numbering: null,
            value: '<p><strong>Bijna</strong> ✍️</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1132447',
            numbering: null,
            value: '<p><strong>Goed </strong>👍</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1132448',
            numbering: null,
            value: '<p><strong>Zeer goed</strong> 👑</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 27,
    time: null,
    title: 'Reflectie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Reflectie</h2>\n<p>Hoe goed denk je dat je de leerdoelen van deze les bereikt hebt? Duid aan wat past voor jou.</p>\n<p class="title-with-background title-with-background--question title-with-background--statement">Ik kan doelgericht nieuwe stijlen ontwerpen in Word.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2132843',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '352672',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1133007',
            numbering: null,
            value: '<p><strong>Helemaal niet goed </strong>😵‍💫</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1133008',
            numbering: null,
            value: '<p><strong>Niet goed </strong>🫤</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1133009',
            numbering: null,
            value: '<p><strong>Bijna</strong> ✍️</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1133010',
            numbering: null,
            value: '<p><strong>Goed </strong>👍</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1133011',
            numbering: null,
            value: '<p><strong>Zeer goed</strong> 👑</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 28,
    time: null,
    title: 'Reflectie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<h2 class="ck5h2">Reflectie</h2>\n<p>Hoe goed denk je dat je de leerdoelen van deze les bereikt hebt? Duid aan wat past voor jou.</p>\n<p class="title-with-background title-with-background--question title-with-background--statement">Ik kan een inhoudstafel genereren op basis van stijlen.</p>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2132844',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [
      {
        id: '352673',
        maxSelectableAnswers: null,
        questionAnswersMultipleChoice: [
          {
            correct: true,
            explanation: '',
            id: '1133012',
            numbering: null,
            value: '<p><strong>Helemaal niet goed </strong>😵‍💫</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1133013',
            numbering: null,
            value: '<p><strong>Niet goed </strong>🫤</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1133014',
            numbering: null,
            value: '<p><strong>Bijna</strong> ✍️</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1133015',
            numbering: null,
            value: '<p><strong>Goed </strong>👍</p>',
          },
          {
            correct: true,
            explanation: '',
            id: '1133016',
            numbering: null,
            value: '<p><strong>Zeer goed</strong> 👑</p>',
          },
        ],
        scorePerCorrectAnswer: '1',
        shouldFindAllCorrect: false,
        shuffleAnswers: false,
        subtractPerWrongAnswer: '0',
        type: 'MULTIPLE_CHOICE',
        value: '',
      },
    ],
    sequence: 29,
    time: null,
    title: 'Reflectie',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
  {
    activityType: null,
    background: null,
    content:
      '<div>\n <h2 class="dotted-in-editor">Doelen en leerwijzer</h2>\n <div class="learnContainer">\n  <div class="mainContent dotted-in-editor">\n   <div class="check-list">\n    <h3 class="ck5h3">Na deze les kan je…</h3>\n    <ul>\n     <li>de functies voor pagina-indeling in Word doelgericht toepassen.</li>\n     <li>doelgericht nieuwe stijlen ontwerpen in Word.</li>\n     <li>een inhoudstafel genereren op basis van stijlen.</li>\n    </ul>\n    <p>&nbsp;</p>\n   </div>\n   <h3>Download hier de leerwijzer voor deze les:</h3>\n   <p><a class="styledLink SlideViewer__StyledButton SlideViewer__DownloadLink cursor-pointer select-none mb-2" target="_blank" rel="noreferrer noopener" download-file-name="ITME2_WordII_L2_Paginaindeling_Leerwijzer" download-url="https://codefeverpublic.blob.core.windows.net/public-content/documents/e4602a5a376c44d2ad4e9e19bdaa8fd8.pdf">&nbsp;Leerwijzer&nbsp;</a>&nbsp;</p>\n   <p>&nbsp;</p>\n   <p>&nbsp;</p>\n   <p>&nbsp;</p>\n   <div class="ftrprfLogo">\n    &nbsp;\n   </div>\n  </div>\n  <div class="dotted-in-editor imagePlaceholder">\n   <span><strong><img class="image_resized" style="width:506px;" src="https://codefeverpublic.blob.core.windows.net/public-content/images/ccab545807814205b8ad7edc30ff00ee.jpg" alt=""></strong></span>\n  </div>\n </div>\n</div>',
    execution: null,
    groupRoles: [],
    hints: [],
    id: '2130877',
    info: null,
    method: null,
    module: null,
    motivation: null,
    part: null,
    questions: [],
    sequence: 30,
    time: null,
    title: 'Doelen en leerwijzer',
    viewModes: ['CLASSICAL', 'PROJECTION', 'SELFSTUDY'],
  },
];
